import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButtonText from '~/components/_next/atoms/AzButtonText.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzRadio from '~/components/_next/molecules/AzRadio.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzAccordionItem from '~/components/_next/molecules/AzAccordionItem.vue';
import AzFilter from '~/components/_next/molecules/AzFilter.vue';
import SortSelector from '~/components/ui/SortSelector.vue';
import ProductCardAlgoliaOrganism from '~/components/_next/organisms/ProductCardAlgoliaOrganism.vue';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import { AisConfigure, AisIndex, AisHits, AisStateResults, AisPagination, AisRefinementList, AisSortBy, AisStats, AisClearRefinements } from 'vue-instantsearch';
import { useLocalization } from '~/composables/_next/useLocalization';
import AzSearchFilterRange from '~/components/_next/molecules/AzSearchFilterRange.vue';
import { useAlgoliaSearch } from '~/composables/_next/useAlgoliaSearch';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import useMobileObserver from '~/composables/useMobileObserver';
import { z } from 'zod';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchProduct',
  props: {
    loading: {
      type: Boolean
    }
  },
  emits: ['productHit'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency,
      country = _useLocalization.country;
    var _useAlgoliaSearch = useAlgoliaSearch(),
      filtersProducts = _useAlgoliaSearch.filtersProducts,
      sortsProducts = _useAlgoliaSearch.sortsProducts,
      indexProduct = _useAlgoliaSearch.indexProduct;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var route = useRoute();
    var router = useRouter();
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR,
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent;
    var aisStateResultsRef = ref(null);
    var numericFilters = computed(function () {
      var minQuery = route.query['min-price'];
      var maxQuery = route.query['max-price'];
      if (!minQuery && !maxQuery) {
        return [];
      }
      var min = parseFloat(minQuery);
      var max = parseFloat(maxQuery);
      var minPrice = !isNaN(min) ? min * 100 : 0;
      var maxPrice = !isNaN(max) ? max * 100 : 1000000;
      return ["variants.prices.EUR.max >= ".concat(minPrice), "variants.prices.EUR.max <= ".concat(maxPrice)];
    });
    var priceFacet = computed(function () {
      return {
        id: 'price',
        options: {
          min: 0,
          max: 100,
          unit: currency
        }
      };
    });
    var sidebar = ref(null);
    var pageSchema = z.coerce.number().catch(1);
    var page = computed(function () {
      var parsedPage = pageSchema.parse(route.query.page);
      return parsedPage > 0 ? parsedPage - 1 : 0;
    });
    var query = computed(function () {
      return route.params.term;
    });

    /**
     * Clears the current URL query parameters by pushing an empty query object.
     */
    function clearURL() {
      router.push({
        query: {}
      });
    }

    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      var _sidebar$value, _sidebar$value$sideba;
      (_sidebar$value = sidebar.value) === null || _sidebar$value === void 0 ? void 0 : (_sidebar$value$sideba = _sidebar$value.sidebar) === null || _sidebar$value$sideba === void 0 ? void 0 : _sidebar$value$sideba.showModal();
    }
    function sendAnalytics(items) {
      var trackedProducts = items === null || items === void 0 ? void 0 : items.map(function (product, i) {
        var _masterVariant$prices;
        var masterVariant = product.variants.find(function (variant) {
          return variant.sku === product.masterVariantID;
        });
        if (!masterVariant) return null;
        var price = (_masterVariant$prices = masterVariant.prices[currency].priceValues.find(function (value) {
          return value.country === country.toUpperCase();
        })) !== null && _masterVariant$prices !== void 0 ? _masterVariant$prices : masterVariant.prices[currency].priceValues.find(function (value) {
          return value.country === 'Any';
        });
        if (!price) return null;
        var regular = price.value;
        var special = price.discountedValue;
        return {
          item_id: "SKU_".concat(masterVariant.sku),
          item_sku: masterVariant.sku,
          item_name: product.name || '',
          item_category: false,
          discount: (regular - special) / 100,
          discount_in_cents: regular - special,
          index: i + 1,
          is_master_in_front: true,
          ct_product_id: product.objectID,
          price: regular / 100,
          price_in_cents: regular,
          currency: currency,
          is_in_stock: product.isAnyVariantInStock
        };
      });
      if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
        $trackers.gtm.pushEvent('generic_event', {
          event_category: 'engagement',
          event_action: 'send',
          event_label: 'search',
          event_name: 'generic_event',
          search_term: query.value
        });
        $trackers.gtm.pushEvent('product_list_view', {
          event_category: 'ecommerce',
          event_action: 'impressions',
          event_name: 'view_item_list',
          ecommerce: {
            items: trackedProducts
          }
        });
        trackDynamicYieldEvent({
          name: 'view_item_list',
          properties: {
            items: trackedProducts
          }
        });
      } else {
        $trackers.gtm.pushEvent('search', {
          event_label: 'empty_search',
          event_name: 'empty_search',
          search_term: query.value
        });
      }
    }
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Search_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Search_Page']);
    watch(function () {
      var _aisStateResultsRef$v, _aisStateResultsRef$v2, _aisStateResultsRef$v3, _aisStateResultsRef$v4;
      return (_aisStateResultsRef$v = aisStateResultsRef.value) === null || _aisStateResultsRef$v === void 0 ? void 0 : (_aisStateResultsRef$v2 = _aisStateResultsRef$v.$data) === null || _aisStateResultsRef$v2 === void 0 ? void 0 : (_aisStateResultsRef$v3 = _aisStateResultsRef$v2.state) === null || _aisStateResultsRef$v3 === void 0 ? void 0 : (_aisStateResultsRef$v4 = _aisStateResultsRef$v3.results) === null || _aisStateResultsRef$v4 === void 0 ? void 0 : _aisStateResultsRef$v4.nbHits;
    }, function (newValue) {
      if (newValue) {
        emit('productHit', newValue);
      }
    });
    watch(function () {
      var _aisStateResultsRef$v5, _aisStateResultsRef$v6, _aisStateResultsRef$v7, _aisStateResultsRef$v8;
      return (_aisStateResultsRef$v5 = aisStateResultsRef.value) === null || _aisStateResultsRef$v5 === void 0 ? void 0 : (_aisStateResultsRef$v6 = _aisStateResultsRef$v5.$data) === null || _aisStateResultsRef$v6 === void 0 ? void 0 : (_aisStateResultsRef$v7 = _aisStateResultsRef$v6.state) === null || _aisStateResultsRef$v7 === void 0 ? void 0 : (_aisStateResultsRef$v8 = _aisStateResultsRef$v7.results) === null || _aisStateResultsRef$v8 === void 0 ? void 0 : _aisStateResultsRef$v8.hits;
    }, function (newValue) {
      if (newValue) {
        sendAnalytics(newValue);
      }
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $trackers: $trackers,
      currency: currency,
      country: country,
      filtersProducts: filtersProducts,
      sortsProducts: sortsProducts,
      indexProduct: indexProduct,
      isMobile: isMobile,
      route: route,
      router: router,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      aisStateResultsRef: aisStateResultsRef,
      numericFilters: numericFilters,
      priceFacet: priceFacet,
      sidebar: sidebar,
      pageSchema: pageSchema,
      page: page,
      query: query,
      clearURL: clearURL,
      openSidebar: openSidebar,
      sendAnalytics: sendAnalytics,
      AzButtonText: AzButtonText,
      MobileFiltersButton: MobileFiltersButton,
      AzSidebar: AzSidebar,
      AzRadio: AzRadio,
      AzButton: AzButton,
      AzAccordionItem: AzAccordionItem,
      AzFilter: AzFilter,
      SortSelector: SortSelector,
      ProductCardAlgoliaOrganism: ProductCardAlgoliaOrganism,
      AzPagination: AzPagination,
      AisConfigure: AisConfigure,
      AisIndex: AisIndex,
      AisHits: AisHits,
      AisStateResults: AisStateResults,
      AisPagination: AisPagination,
      AisRefinementList: AisRefinementList,
      AisSortBy: AisSortBy,
      AisStats: AisStats,
      AisClearRefinements: AisClearRefinements,
      AzSearchFilterRange: AzSearchFilterRange
    };
  }
});